export const localization = () => {
	const language = navigator.languages
		? navigator.languages[0].substring(0, 2)
		: (navigator.language || navigator.userLanguage).substring(0, 2)
	return language ? language : 'en'
}

const dictionary = {
	'January': { de: 'Januar' },
	'February': { de: 'Februar' },
	'March': { de: 'März' },
	'April': { de: 'April' },
	'May': { de: 'Mai' },
	'June': { de: 'Juni' },
	'July': { de: 'Juli' },
	'August': { de: 'August' },
	'September': { de: 'September' },
	'October': { de: 'Oktober' },
	'November': { de: 'November' },
	'December': { de: 'Dezember' }
}

export const translate = (word) => {
	if (localization() === 'de') {
		return !dictionary[word][localization()] ? word : dictionary[word][localization()]
	}
	return word
}
